import React from 'react';
import Typography from '@mui/material/Typography';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from '@mui/lab';
import { FaHistory } from 'react-icons/fa';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Box, Button, Tooltip } from '@mui/material';
import { BsClipboard } from 'react-icons/bs';
import moment from "moment";


const TimelineHistory = ({ items }) => {
    return (
        <Timeline sx={{ padding: "20px", background: "white", borderRadius: "10px"}}>
            {items?.length > 0 ? (
                items.map((item, index) => (
                    <TimelineItem key={index}>
                        {/* Timestamp */}
                        <TimelineOppositeContent
                            sx={{ m: "auto 0", fontSize: "14px", color: "gray" }}
                            align="right"
                        >
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>

                                {moment(item.timestamp).format("MM/DD/YYYY, h:mm:ss a")}
                            </Typography>
                            <CopyToClipboard text={item.txID}>
                                <Button variant="text" startIcon={<BsClipboard />} style={{ padding: '0' }} >
                                    <Tooltip title="Transaction ID" placement='right' arrow>
                                        <div>
                                            {item.txID.substring(0, 4)}...{item.txID.substring(item.txID.length - 3, item.txID.length)}
                                        </div>
                                    </Tooltip>
                                </Button>
                            </CopyToClipboard>
                        </TimelineOppositeContent>

                        {/* Timeline Indicator */}
                        <TimelineSeparator>
                            <TimelineConnector sx={{ bgcolor: "#D3D3D3" }} />
                            <TimelineDot sx={{ bgcolor: "success.main", boxShadow: "0px 0px 8px rgba(0, 255, 0, 0.5)" }}>
                                <FaHistory color="white" />
                            </TimelineDot>
                            <TimelineConnector sx={{ bgcolor: "#D3D3D3" }} />
                        </TimelineSeparator>

                        {/* Timeline Content */}
                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                            {/* Record Name */}
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
                                {item?.Record?.name}
                            </Typography>

                            {/* Updated By */}
                            <Typography variant="h6" color="text.secondary">
                                Updated By:{" "}
                                <Typography component="span" sx={{ fontWeight: "bold", color: "secondary.main" }}>
                                    {item?.Record?.updatedBy ?? "N/A"}
                                </Typography>
                            </Typography>

                            {/* Created By */}
                            <Typography variant="h6" color="text.secondary">
                                Created By:{" "}
                                <Typography component="span" sx={{ fontWeight: "bold", color: "secondary.main" }}>
                                    {item?.Record?.createdBy ?? "N/A"}
                                </Typography>
                            </Typography>

                            {/* Details */}
                            <Box mt={1}>
                                {item?.Record?.details?.map((detail, idx) => (
                                    <Typography
                                        key={idx}
                                        variant="body1"
                                        sx={{
                                            background: detail?.detailValue === "true" ? "#4CAF50" : "#F44336",
                                            color: "white",
                                            display: "inline-block",
                                            padding: "4px 8px",
                                            borderRadius: "6px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {detail?.detailValue === "true" ? "Authorized" : "Unauthorized"}
                                    </Typography>
                                ))}
                            </Box>


                        </TimelineContent>
                    </TimelineItem>
                ))
            ) : (
                <Typography align="center" variant="h5" sx={{ color: "gray", mt: 2 }}>
                    No history available yet.
                </Typography>
            )}
        </Timeline>
    );
};
export default TimelineHistory;